module.exports = __webpack_public_path__ + "img/highSpeedRail-4.91b55e74.jpg";